export enum FeatureSvg {
    AccessDenied = 'AccessDenied',
    AppNoFamily = 'AppNoFamily',
    AppNoGoals = 'AppNoGoals',
    AppNoProducts = 'AppNoProducts',
    AppNoSourceOfWealth = 'AppNoSourceOfWealth',
    ClientCharity = 'ClientCharity',
    ClientCorporate = 'ClientCorporate',
    ClientIndividual = 'ClientIndividual',
    ClientJoint = 'ClientJoint',
    ClientTrust = 'ClientTrust',
    Comments = 'Comments',
    DashboardNoAccess = 'DashboardNoAccess',
    EmptyFolder = 'EmptyFolder',
    InboxEmpty = 'InboxEmpty',
    NoChatData = 'NoChatData',
    NoData = 'NoData',
    NoListData = 'NoListData',
    PageNotFound = 'PageNotFound',
    SelectDataFromMenu = 'SelectDataFromMenu',
    Success = 'Success',
    TableCellsLock = 'TableCellsLock',
    ThumbsUp = 'ThumbsUp',
    UserClock = 'UserClock',
    UserSearch = 'UserSearch',
    Workspace = 'Workspace',
    xMark = 'xMark',
}

export type size = 'xs' | 'sm' | 'md' | 'lg';
